import { Flex, Avatar, Box, Text, Icon } from '@chakra-ui/react';
import { NotificationCard } from '../components/Card';
import { NotificationTime } from '../components/Time';
import OutreachSender from '@/assets/icons/notification/OutreachSender';
import { selectUsers } from '@/store/users/selectors';
import { useSelector } from 'react-redux';
import { decode } from 'js-base64';
import { NotificationLink } from '../components/NotificationLink';

export const AddedAsSender = ({ notification = {}, onClose = () => {} }) => {
  const users = useSelector(selectUsers);
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const outreachCreator = users?.find(
    (user) => user.id === data?.created_by_id
  );

  return (
    <NotificationCard notification={notification}>
      <Flex>
        <Box>
          <Box height="40px" pos="relative">
            <Avatar
              width="36px"
              height="36px"
              borderRadius="8px"
              className="avatar-md"
              name={outreachCreator?.name}
              src={outreachCreator?.avatar}
            />
            <Box pos="absolute" bottom="-24px" left="9px">
              <Icon as={OutreachSender} width="40px" height="40px" />
            </Box>
          </Box>
        </Box>
        <Box ml="12px">
          <Text>
            <Text fontWeight="semiBold" as="span" px="4px">
              {data?.created_by_name}
            </Text>
            have added
            <Text fontWeight="semiBold" as="span" px="4px">
              You
            </Text>
            as a sender in
            <NotificationLink
              to={`/flows/${data?.outreach_id}`}
              label={data?.outreach_name}
              onClose={onClose}
              notification={notification}
              data-test-id="flow-link"
            />
          </Text>
          <NotificationTime notification={notification} />
        </Box>
      </Flex>
    </NotificationCard>
  );
};
